import { axiosInstance } from '@/axios';

const API_URL = '/api/service-requests';

class ServiceRequestssService {

  async list(params) {
    let queryParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
      if (value === null || value === undefined){
        continue;
      }
      queryParams.append(key, value);
    }
    return axiosInstance.get(
        `${API_URL}/list`,
        {
          params: queryParams,
        },
    );
  }

  async get(serviceRequestId) {
    return axiosInstance.get(
        `${API_URL}/get/${serviceRequestId}`);
  }

  async save(serviceRequest, sendMails) {
    let queryParams = new URLSearchParams();
    if (sendMails){
      queryParams.append('sendMails', sendMails);
    }

    return axiosInstance.post(
        `${API_URL}/save`,
        serviceRequest,
        {
          params: queryParams,
        },
    );
  }

  async delete(serviceRequestIds) {
    let data = new FormData();
    serviceRequestIds.forEach(id => data.append('ids', id) );
    return axiosInstance.delete(
        `${API_URL}/delete`,
        { data:data },
    );
  }
}

export default new ServiceRequestssService();
